import ActionTypes from '../../action-types';
import { onPending, onFulfill, onReject } from '../../util';

const initialState = {
  loading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case onPending(ActionTypes.JOB_ACTIVATE):
      return {
        ...state,
        error: null,
        loading: true
      };

    case onFulfill(ActionTypes.JOB_ACTIVATE):
      return {
        ...state,
        error: null,
        loading: false
      };

    case onReject(ActionTypes.JOB_ACTIVATE):
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case onFulfill(ActionTypes.LOGOUT):
      return initialState;
    default:
      return state;
  }
};
